import { reactLocalStorage } from "reactjs-localstorage";
import axiosInstance from "../../../api/axiosInstance";

export const sendSessionClose = (type,sessionId,objectId,isChanged,museum,isClosing) => {
    if (sessionStorage.getItem("justRefreshed") === "true") {
      sessionStorage.setItem("justRefreshed", "false");
      return;
    }

    let currentScreen

    if(type==="collection"){
        currentScreen="collection"
    }else if(type==="digital"){
        currentScreen="photography"
    }else if(type==="conservation"){
        currentScreen="conservation"
    }

    const sessionOpenValues = {
      id: sessionId,
      museum: museum,
      museum_object: objectId,
      screen: currentScreen,
      status: "closed",
      is_changes_made: isClosing?false: isChanged,
    };

    try {
      const token = reactLocalStorage.get("token"); // 👈 same as your axiosInstance
      const userData = JSON.parse(localStorage.getItem("user_info"));

      fetch(
        `${axiosInstance.defaults.baseURL}museumobject/object-session/create-object-session`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(userData?.is_superuser === false
              ? { Museum: userData?.museum }
              : {}),
          },
          body: JSON.stringify(sessionOpenValues),
          keepalive: true, // 👈 ensures it works during unload
        }
      );
    } catch (err) {
      console.error("Fetch send failed:", err);
    }
  };